<template>
  <div class="page-info-box color-red mt10" style="padding: 0.4rem" v-if="isNotice">
    이모티콘 구매 금액은 상주에게 조의금으로 전달됩니다.<br />(VAT 및 일부 수수료 제외, 약관 참조)
  </div>
  <div class="scroll-inner" v-if="!isEmpty(items)">
    <div class="emoticon-wrap">
      <ul class="emoticon-ul">
        <li
          class="emoticon-li"
          :class="selected === index ? 'selected' : ''"
          v-for="(item, index) in items"
          @click="pickItem(item, index)"
          :key="item.emoticonNo"
        >
          <div class="emoticon-thumb">
            <img :src="getImagePath(item?.file?.storedFileName)" alt="emoticon" class="emoticon" />
          </div>
          <template v-if="!currentPath.includes('memorial')">
            <p class="date" v-if="menu === EMOTICON_MENU.MEMORIAL">구매 : {{ regDateFormat(item.regDate) }}</p>
            <p class="price" v-else>{{ formatNumber(item.price) }}원</p>
          </template>
        </li>
      </ul>
    </div>
  </div>

  <EmptyItems content="보유하고 있는 이모티콘이 없습니다" v-if="isEmpty(items) && menu === EMOTICON_MENU.MEMORIAL" />
  <EmptyItems content="현재 등록된 이모티콘이 없습니다." v-if="isEmpty(items) && menu === EMOTICON_MENU.NORMAL" />
  <EmptyItems content="구매할 이모티콘이 없습니다." v-if="isEmpty(items) && menu === EMOTICON_MENU.WATCH" />
</template>
<script setup>
import { formatNumber, getImagePath, isEmpty, regDateFormat } from '@/common/utils/Util';
import { EMOTICON_MENU } from '@/common/constants/ConstCode';
import EmptyItems from '@/components/common/layouts/EmptyItems.vue';
import { computed, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const currentPath = computed(() => proxy.$router?.currentRoute?.value?.fullPath);
const emits = defineEmits(['click']);
const props = defineProps({
  items: {
    type: [Array, Object],
    required: true
  },
  selected: {
    type: [Number, String],
    required: true
  },
  menu: {
    type: String,
    required: true
  },
  isNotice: {
    type: Boolean,
    default: true
  }
});

const pickItem = (item, index) => {
  emits('click', item, index);
};
</script>
